import { render, staticRenderFns } from "./InvestorCategory.vue?vue&type=template&id=b5889696&"
import script from "./InvestorCategory.vue?vue&type=script&lang=js&"
export * from "./InvestorCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports